import React from "react";
import { Link, Outlet } from "react-router-dom";

import { Button } from "primereact/button";
import { FaPhoneAlt } from "react-icons/fa";

import AppCard from "../../../components/appCard";

import { useInfo } from "../../../context/infoContext";
import { isGeracaoBoletoSuspensa, MENSAGEM_GERACAO_SUSPENSA } from "../../../utils/geracaoBoleto";

export default function AdimplenciasLayout() {
    const { credorData } = useInfo();
    const geracaoSuspensa = isGeracaoBoletoSuspensa(credorData);

    return typeof credorData === "object" ? (
        <div>
            {geracaoSuspensa && (
                <div
                    role="alert"
                    className="mb-3 flex items-start gap-3 rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-800 dark:border-yellow-600 dark:bg-yellow-900/30 dark:text-yellow-200"
                >
                    <i className="pi pi-exclamation-triangle mt-1" />
                    <div>
                        <p className="font-bold">Geração de boletos suspensa</p>
                        <p className="text-sm">
                            {MENSAGEM_GERACAO_SUSPENSA} Importações, novos parcelamentos e boletos avulsos
                            estão indisponíveis. Para reativar, contate o suporte da Direto.
                        </p>
                    </div>
                </div>
            )}
            <div>
                <Outlet />
            </div>
        </div>
    ) : (
        <div className="flex justify-center">
            <AppCard>
                <p>Você não possui o serviço de adimplência</p>
                <p>Contate esse número e ative o serviço.</p>
                <a className="flex justify-center mt-2 flex-order-1 gap-2" href="https://wa.me/5511996383405" rel="noopener noreferrer" target="_blank">
                    <FaPhoneAlt className='text-xl' />
                    <div className="text-sm">
                        (11) 99638-3405
                    </div>
                </a>
                <div className="w-full flex justify-center mt-3">
                    <Link to="/dashboard">
                        <Button label="Voltar" />
                    </Link>
                </div>
            </AppCard>
        </div>
    );
}